export default __webpack_public_path__ + "static/perekrestok-bfa0463d6a442a8e8b4797a1bc24c2dd.png";